import React from 'react';
import PropTypes from 'prop-types';

const BeforeOrAfter = ({

name,
  date,
  onClick,
  clicked,
}) => {
  let styles = { };

  if (clicked) {
    styles = { borderColor: 'rgb(25, 97, 172)' };
  }

  return (

    <div className="col-xs-12 col-sm-6 flexStart" onClick={onClick}>
      <div className="productBorder growBox flexObject" style={styles}>
      <h4 >{name}</h4>

      <div className="row ">

        <div className="col-xs-12"> <span className="time">{date}</span></div>


      </div>

      </div>
    </div>


  );
};

/*
  content
  description
  image
  name
  sku
  type
*/
BeforeOrAfter.defaultProps = {
  duration: undefined,
};

BeforeOrAfter.propTypes = {
  name: PropTypes.string.isRequired,
  // content: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  sku: PropTypes.number.isRequired,
  type: PropTypes.string.isRequired,
  costDisplay: PropTypes.string.isRequired,
  durationDisplay: PropTypes.string.isRequired,
  duration: PropTypes.string,


  //
  onClick: PropTypes.func.isRequired,
};

export default BeforeOrAfter;



// WEBPACK FOOTER //
// ./src/components/Resource/components/BeforeOrAfter.jsx